const NAME = "CURRENCY_SETTINGS";

export default NAME;
